import { SITE_URL } from "./seo";

export const SEO_VALUES = [
  { label: "Site / property URL", value: `${SITE_URL}/`, id: "site-url" },
  { label: "Sitemap URL", value: `${SITE_URL}/sitemap.xml`, id: "sitemap-url" },
  { label: "robots.txt", value: `${SITE_URL}/robots.txt`, id: "robots-url" },
  { label: "AI crawler summary (llms.txt)", value: `${SITE_URL}/llms.txt`, id: "llms-url" },
  { label: "Homepage title", value: "Lake Monitor AI | Bathymetric Lake & Reservoir Mapping Services (US & Canada)", id: "home-title" },
];

export const SEO_SECTIONS = [
  {
    id: "before",
    title: "0. Before you submit (5 min)",
    intro: "Do this once the new build is live — submitting a sitemap that returns the old page wastes a crawl.",
    steps: [
      { t: "Republish the latest build", d: "In Emergent click \"Republish changes\", wait for status Live, then hard-refresh lakemonitor.ai." },
      { t: "Confirm the sitemap is real XML", d: "Open https://lakemonitor.ai/sitemap.xml — you should see <urlset> with 71 URLs, not the website. Same for /robots.txt (plain text)." },
      { t: "Spot-check three pages", d: "View source on /, /services and /lake-mapping/ontario: each should have its own <title> and JSON-LD, not \"Emergent | Fullstack App\"." },
      { t: "Check the favicon", d: "https://lakemonitor.ai/favicon.ico should download an icon, not HTML." },
    ],
  },
  {
    id: "google",
    title: "1. Google Search Console",
    intro: "Use a Domain property so http/https and www/non-www are all covered.",
    steps: [
      { t: "Open Search Console", d: "Go to https://search.google.com/search-console and sign in with the Google account that should own the property (your alert Gmail works)." },
      { t: "Add property → Domain", d: "Choose the Domain option (left card) and enter lakemonitor.ai (no https://, no www)." },
      { t: "Verify via DNS TXT record", d: "Google shows a TXT record like google-site-verification=…. Add it at your DNS provider (where lakemonitor.ai's nameservers are managed — Cloudflare if you use Emergent's default). Name/host: @ (root). TTL: auto. Then click Verify. DNS can take 5–60 min." },
      { t: "Submit the sitemap", d: "Left menu → Indexing → Sitemaps → \"Add a new sitemap\" → enter sitemap.xml → Submit. Status should turn to Success with 71 discovered URLs within a day." },
      { t: "Request indexing for key pages", d: "Use the URL Inspection bar at the top: paste https://lakemonitor.ai/, then /services, /request-a-quote, /locations → \"Request indexing\" on each (limit ~10/day)." },
      { t: "Check the Pages report in ~1 week", d: "Indexing → Pages. \"Not indexed → Discovered/Crawled – currently not indexed\" on a few region pages is normal early on. Fix anything under \"Soft 404\" or \"Duplicate\"." },
    ],
  },
  {
    id: "bing",
    title: "2. Bing Webmaster Tools (also feeds DuckDuckGo, Yahoo & Copilot)",
    intro: "Fastest path is to import the verified Google property.",
    steps: [
      { t: "Open Bing Webmaster Tools", d: "Go to https://www.bing.com/webmasters and sign in (Microsoft, Google or Facebook account)." },
      { t: "Import from Google Search Console", d: "Click \"Import\" on the Google option, authorize, pick lakemonitor.ai → Import. Verification and sitemaps copy across automatically." },
      { t: "Or verify manually", d: "\"Add your site manually\" → https://lakemonitor.ai → choose the DNS CNAME option (add the shown CNAME at your DNS provider) → Verify." },
      { t: "Confirm the sitemap", d: "Left menu → Sitemaps → make sure https://lakemonitor.ai/sitemap.xml is listed; if not, click Submit sitemap and add it." },
      { t: "Submit key URLs", d: "URL Submission → paste up to 10 URLs per day: homepage, /services, /solutions, /how-it-works, /request-a-quote, /locations and your top 4 state/province pages." },
      { t: "Turn on IndexNow (optional)", d: "Settings → IndexNow gives you an API key so future page updates can be pushed instantly. Save the key; we can wire it into the build later." },
    ],
  },
  {
    id: "after",
    title: "3. After submission — what to watch",
    steps: [
      { t: "Coverage", d: "Aim for the 6 main pages + /locations indexed within 1–2 weeks; region pages roll in over 4–8 weeks." },
      { t: "Performance → Queries", d: "Look for \"lake mapping <state>\", \"bathymetric survey\", \"pond depth map\". Pages that get impressions but few clicks may need a stronger title/description — tell me and I'll tune them." },
      { t: "Enhancements", d: "Search Console should list FAQ, Breadcrumb and Organization structured data with 0 errors. Any error → send me the URL." },
      { t: "Keep the sitemap fresh", d: "Every republish regenerates sitemap.xml automatically; nothing to resubmit unless you add new pages." },
    ],
  },
];
